import { z } from "zod";

const conditionalBooleanDesignElementSchema = z.object({
	allowed: z.boolean(),
});

const designParameterSchema = z.object({
	alias: z.string(),
	name: z.string(),
});
export type DesignParameter = z.infer<typeof designParameterSchema>;

const lineDirectionSchema = z.number().nullish();

const lineTypeSchema = z.number().nullish();

const lineSchema = z.object({
	condition: z.string().nullable(),
	cutLength: z.string().nullable(),
	direction: lineDirectionSchema,
	endX: z.string().nullable(),
	endY: z.string().nullable(),
	length: z.string(),
	startX: z.string(),
	startY: z.string(),
	type: lineTypeSchema,
	label: z.string().nullable(),
	enabled: z.boolean(),
});

const rotationPermissionsSchema = z.object({
	degree0: conditionalBooleanDesignElementSchema.nullish(),
	degree90: conditionalBooleanDesignElementSchema.nullish(),
	degree180: conditionalBooleanDesignElementSchema.nullish(),
	degree270: conditionalBooleanDesignElementSchema.nullish(),
	degree0Flip: conditionalBooleanDesignElementSchema.nullish(),
	degree90Flip: conditionalBooleanDesignElementSchema.nullish(),
	degree180Flip: conditionalBooleanDesignElementSchema.nullish(),
	degree270Flip: conditionalBooleanDesignElementSchema.nullish(),
});

const usedDesignParameterSchema = z.object({
	alias: z.string(),
	name: z.string(),
});

export const packagingDesignSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	designId: z.number(),
	name: z.string(),
	description: z.string().nullable().optional(),
	author: z.string().nullable().optional(),
	lengthOnZFold: z.string().nullish(),
	widthOnZFold: z.string().nullish(),
	maximumWidthOnZFold: z.string().optional(),
	lines: z.array(lineSchema),
	allowedRotations: rotationPermissionsSchema.optional(),
	allowedRotationNames: z.array(z.string()),
	designParameters: z.array(designParameterSchema),
	usedDesignParameters: z.array(usedDesignParameterSchema),
	wasteAreaParameters: z.unknown().optional(),
	userName: z.string().nullable().optional(),
	messageId: z.string().optional(),
});
export type PackagingDesign = z.infer<typeof packagingDesignSchema>;

const _designFavoriteSchema = z.object({
	id: z.string(),
	isFavorite: z.boolean(),
	designId: z.number(),
});
export type DesignFavorite = z.infer<typeof _designFavoriteSchema>;

const _xmlUploadRequestSchema = z.object({
	ezdString: z.string(),
});
export type XmlUploadRequest = z.infer<typeof _xmlUploadRequestSchema>;

const _generateSvgRequestSchema = z.object({
	designId: z.number(),
	length: z.number(),
	width: z.number(),
	height: z.number(),
	rotation: z.string().optional(),
	thickness: z.number(),
	xValues: z.record(z.string(), z.number()),
});
export type GenerateSvgRequest = z.infer<typeof _generateSvgRequestSchema>;

const errorResponseSchema = z.object({
	code: z.string(),
	message: z.string(),
});
export const generateSvgResponseSchema = z.object({
	svg: z.string().nullable(),
	error: errorResponseSchema.nullable(),
});
export type GenerateSvgResponse = z.infer<typeof generateSvgResponseSchema>;
